import React from "react";
import PageHero from "../components/PageHero";
import Services from "../components/Services";
import HowWeWork from "../components/HowWeWork";
import WhyProspera from "../components/WhyProspera";
import CTABanner from "../components/CTABanner";
import { IMAGES } from "../config/siteConfig";

export default function ServicesPage() {
  return (
    <>
      <PageHero
        label="Services"
        title="We code MERN | MEAN | LAMP | PWA and"
        highlight="Hybrid App stacks."
        subtitle="We Listen, Educate, Strategise, Develop, Correct, Launch and Maintain — with hyper support after go-live."
        image={IMAGES.employers}
      />
      <Services />
      <HowWeWork />
      <WhyProspera />
      <CTABanner heading="Need a reliable delivery partner?" highlight="Let's talk." />
    </>
  );
}
